'use strict';
var parent = require('../../es/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/index-of.js
// module id = 764
// module chunks = 13